import { IconLibraryTypes } from "@liberty-financial/ng-components/lib/components/icon/library.enum";

export const InlineMessageIcons: { [key: string]: IconLibraryTypes } = {
  Default: 'notification',
  Info: 'info',
  Success: 'success',
  Warning: 'warning',
  Error: 'alert',
};

export enum InlineMessageAppearance {
  Default = 'default',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
export type InlineMessageAppearanceET = `${InlineMessageAppearance}`;
